// Shared design tokens for WaveScorePro
// F-109 (Feb 2026) — muted colours re-checked for WCAG AA (4.5:1).
//   Light theme muted (#475569 slate-600) on white  → 7.24:1  (AAA)
//   Dark theme  muted (#8AA5C2)          on #080D1A → 6.10:1  (AA)
//   Term theme  muted (#8AA9CC)          on #090E1A → 6.30:1  (AA)
export const T = {
  navy: "#0A1628",
  green: "#059669",
  greenAccent: "#00C896",
  blue: "#2563EB",
  amber: "#D97706",
  red: "#EF4444",
  border: "#E5E7EB",
  muted: "#475569",           // was #6B7280 — 4.83:1 (borderline AA) → 7.24:1 (AAA)
  mutedSoft: "#64748B",       // secondary muted for less-critical hints (5.7:1, AA)
  bg: "#F8FAFC",
  // Dark broadcast (StationDash)
  dark: {
    bg: "#080D1A",
    surface: "#0F1829",
    card: "#131F33",
    border: "#1E2F48",
    cyan: "#00D4FF",
    cyanDim: "#00D4FF18",
    text: "#E8EFF8",
    muted: "#8AA5C2",         // was #5A7A99 — 3.5:1 (fail) → 6.1:1 (AA)
    dim: "#1E3050",
  },
  // Financial terminal (AdVerify)
  term: {
    bg: "#090E1A",
    surface: "#0F1628",
    card: "#131E30",
    border: "#1C2D45",
    green: "#00C896",
    greenDim: "#00C89618",
    text: "#F0F4FF",
    muted: "#8AA9CC",         // was #7A9BBF — 5.2:1 → 6.3:1 (AA)
    mono: "'DM Mono','Courier New',monospace",
  },
};

export const SOURCE_COLORS = {
  DIRECT: "#059669",
  PANEL: "#D97706",
  MODEL: "#2563EB",
  HYBRID: "#D97706",
};

export const LSM_BANDS = [
  { key: "lsm_1_2",  label: "LSM 1-2",  color: "#EF4444", desc: "Low income" },
  { key: "lsm_3_4",  label: "LSM 3-4",  color: "#F97316", desc: "Emerging" },
  { key: "lsm_5_6",  label: "LSM 5-6",  color: "#EAB308", desc: "Lower-mid" },
  { key: "lsm_7_8",  label: "LSM 7-8",  color: "#22C55E", desc: "Established" },
  { key: "lsm_9_10", label: "LSM 9-10", color: "#3B82F6", desc: "Affluent" },
];

export const AGE_BANDS = [
  { key: "15_24",  label: "15-24",  color: "#F59E0B" },
  { key: "25_34",  label: "25-34",  color: "#10B981" },
  { key: "35_44",  label: "35-44",  color: "#00D4FF" },
  { key: "45_54",  label: "45-54",  color: "#A78BFA" },
  { key: "55plus", label: "55+",    color: "#6B7280" },
];
